import React, { Component } from "react";
import "./style.less";
import MySpread from "./MySpread/index";
import MyReward from "./MyReward/index";
import Welfare from "./Welfare/index";
import RewardRule from "./RewardRule/index";
// import Whirligig from "./Carousel/index";
// 图片的引用
import MoneyPng from "./Image/money.png";
import Training from "./Image/training.png";
import Gift from "./Image/gift.png";
import GetPromotionCode from "./Image/promotionCode.png";
import Share from "./Image/share.png";
import Input from "./Image/input.png";
import GetMoneyPng from "./Image/getMoney.png";

const showWelfares = [
  {
    name: "现金奖励",
    src: MoneyPng,
    title1: "邀请好友订购快站即可获得",
    title2: "现金奖励，上不封顶"
  },
  {
    name: "沙龙培训",
    src: Training,
    title1: "推广突出的大使可",
    title2: "免费参加快站服务商培训沙龙"
  },
  {
    name: "快站有礼",
    src: Gift,
    title1: "推广大使将不定期获得",
    title2: "快站神秘好礼"
  }
];

const showPropcess = [
  {
    name: "",
    src: GetPromotionCode,
    title1: "",
    title2: "获取推广码"
  },
  {
    name: "",
    src: Share,
    title1: "",
    title2: "分享给用户"
  },
  {
    name: "",
    src: Input,
    title1: "",
    title2: "订购时填入邀请码"
  },
  {
    name: "",
    src: GetMoneyPng,
    title1: "",
    title2: "获得现金奖励"
  }
];

class Favorable extends Component {
  
  render() {
    return (
      <div>
        <div className="headImage" />
        <div className="white">
        <div className="coat">
          <div className="blueCut" />
          <div className="title">我的推广</div>
          <MySpread/>
        </div>
        <hr className="contentCut" />
        <div className="coat">
          <div className="blueCut" />
          <div className="title">我的奖励</div>
          <MyReward />
        </div>
        </div>
        <div className="centerTitleCut gray">
          <div className="blueCut centerBlueCut" />
          <div className="title centerTitle">推广福利</div>
          <div className="gutter-example">
            {showWelfares.map((show, index) => (
              <div className="gutter-box">
                <Welfare
                  name={show.name}
                  src={show.src}
                  title1={show.title1}
                  title2={show.title2}
                />
              </div>
            ))}
          </div>
        </div>
        {/* 轮播图位置 */}
        {/* <div className="sliderBox">
          <Whirligig />
        </div> */}
        <div className="centerTitleCut white">
          <div className="blueCut centerBlueCut" />
          <div className="title centerTitle">推广流程</div>
          <div className="gutter-example process">
            {showPropcess.map((show, index) => (
              <div className="gutter-box processBox">
                <Welfare
                  name={show.name}
                  src={show.src}
                  title1={show.title1}
                  title2={show.title2}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="centerTitleCut gray">
          <div className="blueCut centerBlueCut" />
          <div className="title centerTitle">奖励规则</div>
          <div className="rewardTips coat">
            <div>
              每邀请一位用户成功购买快站套餐，即可获得对应奖励，多邀多得，上不封顶!
            </div>
            <div>邀请用户数和奖金金额按月统计，实时打入账户钱包，下月可提现。</div>

            <div className="rewardRule">
              <p>
                <span className="rewardRuleTitle">计算规则</span>
                <span className="rewardRuleTip"> 以站点尊享版包年为例</span>
              </p>
              <p>
                推广5人收益 = 4(人) x 100(元) + 1(人) x 200(元) = 600元
              </p>
              <p>
                推广10人收益 = 4(人) x 100(元) + 5(人) x 200(元) + 1(人) x 300(元) = 1700元
              </p>
              <p>
                推广20人收益 = 4(人) x 100(元) + 5(人) x 200(元) + 11(人) x 300(元) = 4700元
              </p>
            </div>
          
          <RewardRule />
          </div>
        </div>
        <div className="centerTitleCut white">
          <div className="blueCut centerBlueCut" />
          <div className="title centerTitle">常见问题</div>
          <div className="help"><a href="https://wiki.kuaizhan.com/pub/%E7%83%AD%E9%97%A8%E9%97%AE%E9%A2%98/%E4%BC%98%E6%83%A0%E7%A0%81">前往帮助中心查看</a></div>
        </div>
      </div>
    );
  }
}
export default Favorable;
